// @flow

const GraphQLErrors = {
  ERROR: 'error',
  ESCALATION_ERROR: 'escalation_error',
  RECORD_VALIDATION_ERROR: 'record_validation_error'
};

export default GraphQLErrors;
